import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "../../services/dashboardService";
import { Dashboard } from "../../types";

export const useDashboards = () => {
  return useQuery<Dashboard[]>({
    queryKey: ["dashboards"],
    queryFn: async () => dashboardService.list(),
  });
};

